"use strict";
var SoaCollection = require('bunsen/collections/SoaCollection');
var Message = require('bunsen/models/usercomm/Message');
var moment = require('moment');
module.exports = SoaCollection.extend({
    model: Message,
    comparator: function (modelOne, modelTwo) {
        // if a model isn't from server, it should come last
        if (!modelOne.id) {
            return 1;
        }
        if (!modelTwo.id) {
            return -1;
        }
        return moment(modelOne.get('createdDate')).format('X') - moment(modelTwo.get('createdDate')).format('X');
    },
    initialize : function (models, options) {
        this.conversationId = options.conversationId;
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/usercomm/Messages.js
// module id = 167
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55